import loadable from "./loadable";

const Page404 = loadable(() => import("../view/page404"));
const Login = loadable(() => import("../view/cckmweb/Login/Login.js"));
const DashBoard = loadable(() => import("../view/cckmweb/dashboard/index"));
const Navigation = loadable(() => import("../view/cckmweb/navigation/index"));
const Transmitter = loadable(() => import("../view/cckmweb/transmitter/index"));
const SwitchModal = loadable(() => import("../view/cckmweb/switch/index"));
const Receiver = loadable(() => import("../view/cckmweb/receiver/index"));
const Account = loadable(() => import("../view/cckmweb/account/index"));
const Profile = loadable(() => import("../view/cckmweb/profile/index"));
const Log = loadable(() => import("../view/cckmweb/log/index"));

const KISKLogin = loadable(() => import("../view/kiskLogin/index"));
const Nav = loadable(() => import("../view/nav/index"));
const Scenario = loadable(() => import("../view/scenario/index"));
const Office = loadable(() => import("../view/office/index"));
const Products = loadable(() => import("../view/products/index"));
const ProductsNav = loadable(() =>
  import("../view/products/productsNav/index")
);
const Application = loadable(() => import("../view/application/index"));
const ApplicationNav = loadable(() =>
  import("../view/application/appnav/index")
);
const CCKMDemo = loadable(() => import("../view/cckmdemo/index"));
const BattleTable = loadable(() => import("../view/battleTable/index"));

const Settingnav = loadable(() => import("../view/cckmweb/settingnav/index"));
const General = loadable(() => import("../view/cckmweb/setting/general/index"));
const Anms = loadable(() => import("../view/cckmweb/setting/anms/index"));
const Backuprestore = loadable(() =>
  import("../view/cckmweb/setting/backuprestore/index")
);
const Fwupgrade = loadable(() =>
  import("../view/cckmweb/setting/fwupgrade/index")
);
const Redundancy = loadable(() =>
  import("../view/cckmweb/setting/redundancy/index")
);
const Sessions = loadable(() =>
  import("../view/cckmweb/setting/sessions/index")
);
const Certificates = loadable(() =>
  import("../view/cckmweb/setting/certificates/index")
);

export {
  KISKLogin,
  Nav,
  Scenario,
  Office,
  Products,
  ProductsNav,
  Application,
  ApplicationNav,
  CCKMDemo,
  BattleTable,
  Page404,
  Login,
  DashBoard,
  Navigation,
  Transmitter,
  SwitchModal,
  Receiver,
  Account,
  Profile,
  Log,
  Settingnav,
  General,
  Anms,
  Backuprestore,
  Fwupgrade,
  Redundancy,
  Sessions,
  Certificates,
};
